import Vue from 'vue'
import { securedAxiosInstance } from '@/backend/axios'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    phases: [],
    fixedStatuses: [],
    statuses: [],
    responsibles: [],
    allStatuses: [],
    scoutDisplayItems: [],
    interviewPlaces: []
  },
  mutations: {
    clearSettings (state) {
      Vue.set(state, 'phases', [])
      Vue.set(state, 'fixedStatuses', [])
      Vue.set(state, 'statuses', [])
      Vue.set(state, 'responsibles', [])
      Vue.set(state, 'allStatuses', [])
      Vue.set(state, 'scoutDisplayItems', [])
      Vue.set(state, 'interviewPlaces', [])
    },
    setSetting (state, { key, data }) {
      Vue.set(state, key, data)
    },
    setScoutDisplayItems (state, { data }) {
      Vue.set(state, 'scoutDisplayItems', data)
    },
    setInterviewPlaces (state, { data }) {
      Vue.set(state, 'interviewPlaces', data)
    }
  },
  getters: {
    phases (state) {
      return state.phases
    },
    statuses (state) {
      return state.statuses
    },
    fixedStatuses (state) {
      return state.fixedStatuses
    },
    responsibles (state) {
      return state.responsibles
    },
    allStatuses (state) {
      return state.allStatuses
    },
    scoutDisplayItems (state) {
      return state.scoutDisplayItems
    },
    interviewPlaces (state) {
      return state.interviewPlaces
    }
  },
  actions: {
    clearSettings ({ commit }) {
      commit('clearSettings')
    },
    storeSetting ({ commit }, key) {
      return securedAxiosInstance.get(`/settings/entry/${_.snakeCase(key)}`)
        .then(response => {
          commit('setSetting', { key: key, data: response.data })
        })
    },
    storeResponsibleSetting ({ commit }, key) {
      return securedAxiosInstance.get(`/settings/${_.snakeCase(key)}`)
        .then(response => {
          commit('setSetting', { key: key, data: response.data })
        })
    },
    storeScoutDisplayItems ({ commit }) {
      return securedAxiosInstance.get('/scout/view/display_items')
        .then(response => {
          commit('setScoutDisplayItems', { data: response.data })
        })
    },
    storeInterviewPlaces ({ commit }) {
      return securedAxiosInstance.get('/company/settings/entry/interview_place')
        .then(response => {
          commit('setInterviewPlaces', { data: response.data })
        })
    }
  }
}
